export const FORM_CONTROL_SIZES = {
  SMALL: 'sm',
  LARGE: 'lg',
} as const;

export const FORM_TEXT_TYPES = {
  DEFAULT: 'default',
  VALID: 'valid',
  INVALID: 'invalid',
  WARNING: 'warning',
  CRITERIA_EMPTY: 'criteria-empty',
  CRITERIA_VALID: 'criteria-valid',
  CRITERIA_INVALID: 'criteria-invalid',
} as const;
